<div class="topbar" (click)="closeDropdowns()">
  <div class="d-flex justify-content-between align-items-center gap-4">
    <button class="btn btn-light" (click)="menuToggle.emit()">
      <i class="bi bi-list"></i>
    </button>
    <div class="logo">
      <div class="logo-mark">T</div>
      <span class="logo-text">Trendly <span>Admin</span></span>
    </div>
  </div>

  <div class="d-flex align-items-center gap-2"></div>

  <div class="d-flex align-items-center gap-3">

    <!-- Notifications -->
    <div class="dropdown-wrapper" (click)="$event.stopPropagation()">
      <button class="btn btn-light-400 position-relative me-2"
        (click)="toggleNotificationDropdown()"
        [class.active]="notificationDropdownOpen">
        🔔
        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger notifi">0</span>
      </button>
      <ul class="dropdown-menu dropdown-menu-end p-2" [class.show]="notificationDropdownOpen">
        <small>No new notifications</small>
      </ul>
    </div>

    <!-- Profile Dropdown -->
    <div class="dropdown-wrapper" (click)="$event.stopPropagation()">
      <button class="btn btn-light dropdown-toggle d-flex align-items-center gap-2"
        (click)="toggleProfileDropdown()"
        [class.active]="profileDropdownOpen">

        <div class="profile-img d-flex align-items-center justify-content-center"
            style="background:var(--surface,#f1f5f9);border-radius:50%;font-size:18px">
            👤
          </div>

        <span>{{ auth.admin()?.fullName || auth.admin()?.email || 'Admin' }}</span>
      </button>

      <ul class="dropdown-menu dropdown-menu-end" [class.show]="profileDropdownOpen">
        @if (auth.admin()) {
          <li>
            <div class="px-3 py-2 border-bottom mb-1">
              <div style="font-weight:600;font-size:13px">{{ auth.admin()!.fullName }}</div>
              <div style="font-size:11px;color:var(--muted)">{{ auth.admin()!.email }}</div>
              @if (auth.admin()!.role) {
                <div style="font-size:10px;color:var(--muted);margin-top:2px;text-transform:capitalize">
                  {{ auth.admin()!.role.replace('_', ' ') }}
                </div>
              }
            </div>
          </li>
        }
        <li>
          <a class="dropdown-item text-danger" href="#"
            (click)="logout(); $event.preventDefault()">
            <i class="bi bi-box-arrow-right"></i> Logout
          </a>
        </li>
      </ul>
    </div>

  </div>
</div>